
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckoutPaymentCard',
  emits: ['toggle', 'update:dataEcash', 'update:dataPix', 'update:dataCreditCard', 'update-form'],
  props: {
    options: { type: Array, required: true },
    dataEcash: { type: String, required: true },
    dataPix: { type: String, required: true },
    dataCreditCard: { type: String, required: true },
    totalPrice: { type: Number, required: true },
    eCashBalance: { type: Number, required: true },
    cardInfo: { type: Array, required: true },
    personalInfo: { type: Array, required: true },
    form: { type: Object, required: true },
    errors: { type: Object, required: true },
    months: { type: Array, required: true },
    years: { type: Array, required: true },
    states: { type: Array, required: true },
  },
  computed: {
    missingValue(): string {
      const eCash = this.parseMoney(this.dataEcash);
      const pix = this.parseMoney(this.dataPix);
      const creditCard = this.parseMoney(this.dataCreditCard);
      const diff = this.totalPrice - (eCash + pix + creditCard);

      if (diff > 0) return `Valor em falta ${this.formatCurrency(diff)}`;
      if (diff < 0) return `Valor ultrapassado ${this.formatCurrency(Math.abs(diff))}`;
      return '';
    },
  },
  methods: {
    parseMoney(value: string) {
      return parseFloat((value || '0').replaceAll('.', '').replace(',', '.')) || 0;
    },
    formatCurrency(value: number) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
      }).format(value || 0);
    },
  },
});
